import { Icon, IconProps } from "../";

export const PillIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.22195 11.2929C1.87881 13.636 1.87881 17.435 4.22195 19.7782C6.5651 22.1213 10.3641 22.1213 12.7072 19.7782L15.7124 16.773L19.7783 12.7071C22.1214 10.364 22.1214 6.56497 19.7783 4.22183C17.4352 1.87868 13.6362 1.87868 11.293 4.22183L9.34848 6.16637C9.05558 6.45926 9.05558 6.93414 9.34848 7.22703C9.64137 7.51992 10.1162 7.51992 10.4091 7.22703L12.3537 5.28249C14.111 3.52513 16.9603 3.52513 18.7176 5.28249C20.475 7.03984 20.475 9.88909 18.7176 11.6464L15.1821 15.182L8.28782 8.28769C7.99492 7.9948 7.52005 7.9948 7.22716 8.28769L4.22195 11.2929Z"
      />
    </Icon>
  );
};
